import { RouterModule, Routes } from '@angular/router';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { SegmentoListadoComponent } from './segmentos/segmento-listado.component';
import { SegmentoDetalleComponent } from './segmentos/segmento-detalle.component';
import { NivelesListadoComponent } from './niveles/niveles-listado.component';
import { CanalesListadoComponent } from './canales/canales-listado.component';
import { CanalesEditarComponent } from './canales/canales-editar.component';
import { CanalesDetalleComponent } from './canales/canales-detalle.component';
import { NivelesAgregarComponent } from './niveles/niveles-agregar.component';
import { AliadosListadoComponent } from './aliados/aliados-listado.component';
import { NivelesDetalleComponent } from './niveles/niveles-detalle.component';
import { NivelesRangoUsuarioComponent } from './niveles/niveles-rango-usuario.component';
import { AuthGuard } from '../_guards/auth.guard';
import { ZonasListadoComponent } from './zonas/zonas-listado.component';
import { ZonasTransferenciaComponent } from './zonas/zonas-transferencia.component';
import { AliadosSeleccionarComponent } from './aliados/aliados-seleccionar.component';
import { BancoPreguntasListadoComponent } from './banco-preguntas/banco-preguntas-listado.component';
import { BancoPreguntasEditarComponent } from './banco-preguntas/banco-preguntas-editar.component';
import { CuestionariosListadoComponent } from './cuestionarios/cuestionarios-listado.component';
import { AgendaListadoComponent } from './agenda/agenda-listado.component';
import { AgendaAsignarComponent } from './agenda/agenda-asignar.component';
import { EstructuraFisicaListadoComponent } from './estructura-fisica/estructura-fisica-listado.component';
import { EstructuraFisicaAsignarEjecutivoComponent } from './estructura-fisica/estructura-fisica-asignar-ejecutivo.component';
import { CuestionariosEditarComponent } from './cuestionarios/cuestionarios-editar.component';
import { AgendaDetalleComponent } from './agenda/agenda-detalle.component';
import { EstadosListadoComponent } from './estados/estados-listado.component';
import { EstadosEditarComponent } from './estados/estados-editar.component';
import { EstadosDetalleComponent } from './estados/estados-detalle.component';
import { PerfilesRiesgoListadoComponent } from './perfiles-riesgo/perfiles-riesgo-listado.component';
import { PerfilesRiesgoEditarComponent } from './perfiles-riesgo/perfiles-riesgo-editar.component';
import { PerfilesRiesgoDetalleComponent } from './perfiles-riesgo/perfiles-riesgo-detalle.component';
import { CuestionariosDetalleComponent } from './cuestionarios/cuestionarios-detalle.component';
import { BancoPreguntasDetalleComponent } from './banco-preguntas/banco-preguntas-detalle.component';
import { ProductoListadoComponent } from './producto/producto-listado.component';
import { ProductosTroncalComponent } from './productos-troncal/productos-troncal.component';
import { ProductosTroncalEditarComponent } from './productos-troncal/productos-troncal-editar.component';
import { ProductosTroncalDetalleComponent } from './productos-troncal/productos-troncal-detalle.component';
import { ProductoEditarComponent } from './producto/producto-editar.component';
import { EstructuraFisicaDetalleComponent } from './estructura-fisica/estructura-fisica-detalle.component';
import { PoliticasCreditoListadoComponent } from './politicas-credito/politicas-credito-listado.component';
import { PoliticasCreditoEditarComponent } from './politicas-credito/politicas-credito-editar.component';
import { ConceptoFacturacionListadoComponent } from './conceptos-facturacion/concepto-facturacion-listado.component';
import { ConceptoFacturacionEditarComponent } from './conceptos-facturacion/concepto-facturacion-editar.component';
import { ConceptoFacturacionDetalleComponent } from './conceptos-facturacion/concepto-facturacion-detalle.component';
import { ControlListadoComponent } from './controles/control-listado.component';
import { ControlEditarComponent } from './controles/control-editar.component';
import { PalabraClaveListadoComponent } from './palabras-claves/palabra-clave-listado.component';
import { PalabraClaveDetalleComponent } from './palabras-claves/palabra-clave-detalle.component';
import { PalabraClaveEditarComponent } from './palabras-claves/palabra-clave-editar.component';
import { SincronizacionListadoComponent } from './sincronizaciones/sincronizacion-listado.component';
import { SincronizacionEditarComponent } from './sincronizaciones/sincronizacion-editar.component';
import { ProductoDetalleComponent } from './producto/producto-detalle.component';
import { PoliticasCreditoDetalleComponent } from './politicas-credito/politicas-credito-detalle.component';
import { TipoCausalListadoComponent } from './tipo-causal/tipo-causal-listado.component';
import { TipoCausalEditarComponent } from './tipo-causal/tipo-causal-editar.component';
import { EstadosRolComponent } from './estados/estados-rol.component';
import { TipoOcupacionConfiguracionListadoComponent } from './tipo-ocupacion-configuracion/tipo-ocupacion-configuracion-listado.component';
import { TipoOcupacionConfiguracionEditarComponent } from './tipo-ocupacion-configuracion/tipo-ocupacion-configuracion-editar.component';
import { TipoOcupacionConfiguracionDetalleComponent } from './tipo-ocupacion-configuracion/tipo-ocupacion-configuracion-detalle.component';
import { CapacidadPagoOcupacionComponent} from './capacidad-pago-ocupacion/capacidad-pago-ocupacion.component';
import { SegmentoEditarComponent } from './segmentos/segmento-editar.component';
import { RequisitosListadoComponent } from './requisitos/requisitos-listado.component';
import { RequisitosEditarComponent } from './requisitos/requisitos-editar.component';
import { RequisitosDetalleComponent } from './requisitos/requisitos-detalle.component';
import { CentralRiesgoIntegracionListadoComponent } from './central-riesgo/central-riesgo-integracion-listado.component';
import { CentralRiesgoIntegracionEditarComponent } from './central-riesgo/central-riesgo-integracion-editar.component';
import { CentralRiesgoIntegracionDetalleComponent } from './central-riesgo/central-riesgo-integracion-detalle.component';
import { CuentaContableComponent } from './cuenta-contable/cuenta-contable.component';
import { SeguroListadoComponent } from './seguro/seguro-listado.component';
import { SeguroEditarComponent } from './seguro/seguro-editar.component';
import { SeguroDetalleComponent } from './seguro/seguro-detalle.component';
import { TipoRespaldoListadoComponent } from './tipo-respaldo/tipo-respaldo-listado.component';
import { TipoRespaldoEditarComponent } from './tipo-respaldo/tipo-respaldo-editar.component';
import { EstructuraOficinaComponent } from './estructura-fisica/estructura-oficina/estructura-oficina.component';
import { TipoRespaldoDetalleComponent } from './tipo-respaldo/tipo-respaldo-detalle.component';
import { TipoRespaldoDetalleSubcategoriaComponent } from './tipo-respaldo/tipo-respaldo-detalle-subcategoria.component';
import { VinculacionTerceroComponent } from './vinculacion-tercero/vinculacion-tercero.component';
import { MenuVisitaComponent } from './menu-visita/menu-visita.component';
import { VinculacionTerceroVinculacionComponent } from './vinculacion-tercero/vinculacion-tercero-vinculacion.component';
import { VinculacionTerceroOcupacionComponent } from './vinculacion-tercero/vinculacion-tercero-ocupacion.component';
import { ProcesoProductivoListadoComponent } from './proceso-productivo/proceso-productivo-listado.component';
import { ProcesoProductivoEditarComponent } from './proceso-productivo/proceso-productivo-editar.component';
import { ProcesoProductivoDetalleComponent } from './proceso-productivo/proceso-productivo-detalle.component';
import { PlagaListadoComponent } from './plaga/plaga-listado.component';
import { PlagaEditarComponent } from './plaga/plaga-editar.component';
import { VinculacionTerceroDetalleSubmenuComponent } from './vinculacion-tercero/vinculacion-tercero-detalle-submenu.component';
import { PlagaDetalleComponent } from './plaga/plaga-detalle.component';
import { FormaDesembolsoComponent } from './forma-desembolso/forma-desembolso.component';
import { ModalidadesListadoComponent } from './modalidades/modalidades-listado.component';
import { ModalidadesEditarComponent } from './modalidades/modalidades-editar.component';
import { AlertaListadoComponent } from './alertas/alerta-listado.component';
import { AlertaEditarComponent } from './alertas/alerta-editar.component.ts/alerta-editar.component';
import { VinculacionEstadoFinancieroComponent } from './vinculacion-estado-financiero/vinculacion-estado-financiero.component';
import { ModalidadesDetalleComponent } from './modalidades/modalidades-detalle.component';
import { AlertaDetalleComponent } from './alertas/alerta-detalle.component.ts/alerta-detalle.component';
import { ConveniosComponent } from './convenios/convenios.component';
import { HomologacionEstadoComponent } from './homologacion-estado/homologacion-estado.component';
import { ConveniosEditarComponent } from './convenios/convenios-editar/convenios-editar.component';
import { ConveniosDetalleComponent } from './convenios/convenios-detalle/convenios-detalle.component';
import { FaseListadoComponent } from './fases/fase-listado.component';
import { FaseEditarComponent } from './fases/fase-editar.component';
import { FaseDetalleComponent } from './fases/fase-detalle.component';
import { AsignarGruposComponent } from './estructura-fisica/grupos/asignar-grupos.component';
import { AsignarGruposEditarComponent } from './estructura-fisica/grupos/asignar-grupos-editar.component';
import { AsignarGruposDetalleComponent } from './estructura-fisica/grupos/asignar-grupos-detalle.component';
import { ExcepcionesGmfListadoComponent } from './excepciones-gmf/excepciones-gmf-listado.component';
import { ExcepcionesGmfEditarComponent } from './excepciones-gmf/excepciones-gmf-editar.component';
import { CampaniasDetalleComponent } from './campanias/campanias-detalle.component';
import { CampaniasEditarComponent } from './campanias/campanias-editar.component';
import { CampaniasListadoComponent } from './campanias/campanias-listado.component';
import { CambioPerfilComponent } from './cambio-perfil/cambio-perfil.component';
import { CambioPerfilEditarComponent } from './cambio-perfil/cambio-perfil-editar/cambio-perfil-editar.component';
import { ExcepcionesGmfDetalleComponent } from './excepciones-gmf/excepciones-gmf-detalle.component';
import { SistemaListadoComponent } from './sistemas/sistema-listado.component';
import { SistemaEditarComponent } from './sistemas/sistema-editar.component';
import { ExtensionesTelefonicasListadoComponent } from './extensiones-telefonicas/extensiones-telefonicas-listado.component';
import { ExtensionesTelefonicasEditarComponent } from './extensiones-telefonicas/extensiones-telefonicas-editar.component';
import { BancoErrorIntegracionListadoComponent } from './banco-error/banco-error-integracion-listado.component';
import { BancoErrorIntegracionEditarComponent } from './banco-error/banco-error-integracion-editar.component';
import { BancoErrorIntegracionDetalleComponent } from './banco-error/banco-error-integracion-detalle.component';
import { SolicitudBloqueoSarlaftListadoComponent } from './solicitudes-bloqueo-sarlaft/solicitud-bloqueo-sarlaft-listado.component';
import { AlfrescoComponent } from './alfresco/alfresco.component';
import { EstadosBotonesComponent } from './estados/estados-botones.component';
import { AliadosSucursalesListadoComponent } from './aliados/aliados-sucursales-listado.component';
import { AliadosSucursalesDetalleComponent } from './aliados/aliados-sucursales-detalle.component';
import { AliadosSucursalesEditarComponent } from './aliados/aliados-sucursales-editar.component';
import { FlujoVentaComponent } from './flujo-venta/flujo-venta.component';
import {PaqueteSegurosListadoComponent} from './paquete-seguros/paquete-seguros-listado.component';
import {PaqueteSegurosEditarComponent} from './paquete-seguros/paquete-seguros-editar.component';
import {PaqueteSegurosDetalleComponent} from './paquete-seguros/paquete-seguros-detalle.component';
import {MatrizIdentidadListadoComponent} from './matriz-identidad/matriz-identidad-listado.component';
import {MatrizIdentidadEditarComponent} from './matriz-identidad/matriz-identidad-editar.component';
import { EstadosCausalComponent } from './estados/estados-causal.component';
import {MatrizIdentidadAgregarComponent} from './matriz-identidad/matriz-identidad-agregar.component';
import {GarantiaIdoneasListadoComponent} from './garantias-idoneas/garantia-idoneas-listado.component';
import {GarantiaIdoneasEditarComponent} from './garantias-idoneas/garantia-idoneas-editar.component';
import {GarantiaIdoneasDetalleComponent} from './garantias-idoneas/garantia-idoneas-detalle.component';
import {AdmgarComponent} from './administrador-garantias-idoneas/admgar.component';
import {AdmsbListadoComponent} from './administrador-servicios-bancarios/admsb-listado/admsb-listado.component';
import {AdmsbTitularComponent} from './administrador-servicios-bancarios/admsb-titular/admsb-titular.component';
import {AdmsbTarifasComponent} from './administrador-servicios-bancarios/admsb-tarifas/admsb-tarifas.component';
import {TipoProductoresListadoComponent} from './tipos-productores/tipo-productores-listado.component';
import {TipoProductoresEditarComponent} from './tipos-productores/tipo-productores-editar.component';
import {TipoProductoresDetalleComponent} from './tipos-productores/tipo-productores-detalle.component';
import { CanalEstadoFormComponent } from './configuracion-canal-estado/canal-estado-form.component';
import {ConfiguracionCanalEstadoListadoComponent} from './configuracion-canal-estado/configuracion-canal-estado-listado.component';
import {CanalEstadoDetalleComponent} from './configuracion-canal-estado/canal-estado-detalle.component';
import { UnidadesMedidaComponent } from './unidades-medida/unidades-medida.component';
import { PoliticasComponent } from './politicas/politicas.component';
import {PolitcasFormularioComponent} from './politicas/politcas-formulario/politcas-formulario.component';
import { ReglasNegocioComponent } from './reglas-negocio/reglas-negocio.component';
import { PlanesCargosListadosComponent } from './planes-cargos/planes-cargos-listados/planes-cargos-listados.component';
import { PlanesCargosEditarComponent } from './planes-cargos/planes-cargos-editar/planes-cargos-editar.component';
import { PlanesCargosDetalleComponent } from './planes-cargos/planes-cargos-detalle/planes-cargos-detalle.component';
import { PoliticasDurasListadoComponent } from './politicas-duras/politicas-duras-listado.component';
import { PoliticasDurasDetalleComponent } from './politicas-duras/politicas-duras-detalle/politicas-duras-detalle.component';
import { PoliticasDurasEditarComponent } from './politicas-duras/politicas-duras-editar/politicas-duras-editar.component';
import {PagaduriaComponent} from './pagaduria/pagaduria-editar.component';
import {PagaduriaListadoComponent} from './pagaduria/pagaduria-listado/pagaduria-listado.component';
import { PagaduriaDetalleComponent } from './pagaduria/pagaduria-detalle/pagaduria-detalle.component';
import { ComisionFreelanceListadoComponent } from './comision-freelance/comision-freelance-listado.component';
import { ComisionFreelanceEditarComponent } from './comision-freelance/comision-freelance-editar/comision-freelance-editar.component';
import { ComisionFreelanceDetalleComponent } from './comision-freelance/comision-freelance-detalle/comision-freelance-detalle.component';
import {HomologacionPlanesCargosListadoComponent} from './homologacion-planes-cargos/homologacion-planes-cargos-listado.component';
import {HomologacionPlanesCargosEditarComponent} from './homologacion-planes-cargos/homologacion-planes-cargos-editar/homologacion-planes-cargos-editar.component';
import {ConveniosPlanCargoListadoComponent} from './convenios-planes-cargos/convenios-plan-cargo-listado.component';
import {ConveniosPlanCargoEditarComponent} from './convenios-planes-cargos/convenios-plan-cargo-editar/convenios-plan-cargo-editar.component';
import {ConveniosPlanCargosDetalleComponent} from './convenios-planes-cargos/convenios-plan-cargos-detalle/convenios-plan-cargos-detalle.component';
import { ComiteCreditoComponent } from './comite-credito/comite-credito/comite-credito.component';
import { ServidoresAlfrescoComponent } from './servidores-alfresco/servidores-alfresco.component';
import { ServidoresAlfrescoEditarComponent } from './servidores-alfresco/servidores-alfresco-editar/servidores-alfresco-editar.component';
import { SarlaftComponent } from './sarlaft/sarlaft.component';
import { SarlaftEditarNivelesComponent } from './sarlaft/sarlaft-niveles/sarlaft-editar-niveles/sarlaft-editar-niveles.component';
import { SarlaftEditarVariablesComponent } from './sarlaft/sarlaft-variables/sarlaft-editar-variables/sarlaft-editar-variables.component';
import {
  TasasVariablesListadoComponent
} from "./administrador-tasas-variables/tasas-variables-listado/tasas-variables-listado.component";
import {
  TasasVariablesEditarComponent
} from "./administrador-tasas-variables/tasas-variables-editar/tasas-variables-editar.component";
import {VerDetalleTasasComponent} from "./administrador-tasas-variables/ver-detalle-tasas/ver-detalle-tasas.component";
import { MetaVentaSegurosComponent } from './seguro/meta-venta-seguros/meta-venta-seguros.component';
import {CommonModule} from '@angular/common';
import { SimuladorPantallaGeneralComponent } from './simulador-credito/simulador-pantalla-general.component';
import { PerfilCrezcamosGeneralComponent } from './perfil-crezcamos/perfil-crezcamos-general.component';
import {TopeInversionComponent} from './tope-inversion/tope-inversion.component';
import {TopeInversionDetalleComponent} from './tope-inversion/tope-inversion-detalle/tope-inversion-detalle.component';
import {TopeInversionEditarComponent} from './tope-inversion/tope-inversion-editar/tope-inversion-editar.component';
import { VigenciasAplComponent } from './vigencias/vigencias-apl.component';
import { ValidityRequestsAddComponent } from './vigencias/vigencias-solicitud/validity-requests-add.component';
import { ValidityEmployeesAddComponent } from './vigencias/vigencias-tercero/validity-employees-add.component';
import { AdministrationDocumentsAddComponent } from './vigencias/vigencias-documentos/administration-documents-add.component';
import { AdministrationDocumentsDetailComponent } from './vigencias/vigencias-documentos/administration-documents-detail.component';


const modulo = 'apl';

const aplRoutes: Routes = [
  // Canales
  { path: 'canales', component: CanalesListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'canales/agregar', component: CanalesEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  {
    path: 'canales/actualizar/:id',
    component: CanalesEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  { path: 'canales/detalle/:id', component: CanalesDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },
  // Segmentos
  { path: 'segmentos', component: SegmentoListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'segmentos/agregar', component: SegmentoEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  {
    path: 'segmentos/actualizar/:id',
    component: SegmentoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'segmentos/detalle/:id',
    component: SegmentoDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Niveles
  { path: 'niveles', component: NivelesListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'niveles/agregar', component: NivelesAgregarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  {
    path: 'niveles/actualizar/:id',
    component: NivelesAgregarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  { path: 'niveles/detalle/:id', component: NivelesDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },
  {
    path: 'niveles/rangoUsuario/:id',
    component: NivelesRangoUsuarioComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },

  // Aliados
  { path: 'aliados', component: AliadosListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'aliados/seleccionar-tercero',
    component: AliadosSeleccionarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'aliados/seleccionar-tercero/:id',
    component: AliadosSeleccionarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'aliados/sucursales/:id',
    component: AliadosSucursalesListadoComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E', 'C' ], modulo: modulo }
  },
  {
    path: 'aliados/sucursales/:id/actualizar/:idSucursal',
    component: AliadosSucursalesEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E', 'C' ], modulo: modulo }
  },
  {
    path: 'aliados/sucursales/:id/agregar',
    component: AliadosSucursalesEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E', 'C' ], modulo: modulo }
  },
  {
    path: 'aliados/sucursales/:id/detalle/:idSucursal',
    component: AliadosSucursalesDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  {
    path: 'aliados/sucursales/:id/detalle/:idSucursal/todo',
    component: AliadosSucursalesDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo, todo: true }
  },
  {
    path: 'aliados/detalle/:id',
    component: AliadosSucursalesListadoComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo, detalle: true }
  },

  // Banco preguntas
  { path: 'preguntas', component: BancoPreguntasListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'preguntas/agregar',
    component: BancoPreguntasEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'preguntas/actualizar/:id',
    component: BancoPreguntasEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'preguntas/detalle/:id',
    component: BancoPreguntasDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },

  // Cuestionarios
  { path: 'cuestionarios', component: CuestionariosListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'cuestionarios/agregar', component: CuestionariosEditarComponent, data: { tipo: [ 'C' ], modulo: modulo } },
  {
    path: 'cuestionarios/actualizar/:id',
    component: CuestionariosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'cuestionarios/detalle/:id',
    component: CuestionariosDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },

  // Zonas
  /*{ path: 'zonas', component: ZonasListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'zonas/agregar', component: ZonasEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'zonas/actualizar/:id', component: ZonasEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'zonas/detalle/:id', component: ZonasDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },*/
  { path: 'zonas-traslado', component: ZonasTransferenciaComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Agenda
  { path: 'agenda', component: AgendaListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'agenda/asignar/:id', component: AgendaAsignarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'agenda/detalle/:id', component: AgendaDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },

  // Estructua fisica
  { path: 'estructura-fisica', component: EstructuraFisicaListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'estructura-fisica/asignar-ejecutivo/:id',
    component: EstructuraFisicaAsignarEjecutivoComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'estructura-fisica/asignar-zona/:id',
    component: ZonasListadoComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'estructura-fisica/detalle/:id',
    component: EstructuraFisicaDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  /** Asignar grupos - Estructura física */
  {
    path: 'estructura-fisica/asignar-grupo/:id',
    component: AsignarGruposComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'estructura-fisica/asignar-grupo/:idEstructura/agregar',
    component: AsignarGruposEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'estructura-fisica/asignar-grupo/detalle/:id',
    component: AsignarGruposDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  {
    path: 'estructura-fisica/asignar-grupo/:idEstructura/editar/:id',
    component: AsignarGruposEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  // Estados
  { path: 'estados', component: EstadosListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'estados/agregar', component: EstadosEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  {
    path: 'estados/actualizar/:id',
    component: EstadosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  { path: 'estados/detalle/:id', component: EstadosDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },
  {
    path: 'estados/roles/:id',
    component: EstadosRolComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'estados/botones/:id',
    component: EstadosBotonesComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'estados/causales/:id',
    component: EstadosCausalComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },

  // Perfiles de riesgo
  { path: 'perfiles-riesgo', component: PerfilesRiesgoListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'perfiles-riesgo/agregar',
    component: PerfilesRiesgoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'perfiles-riesgo/actualizar/:id',
    component: PerfilesRiesgoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'perfiles-riesgo/detalle/:id',
    component: PerfilesRiesgoDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Productio
  { path: 'producto', component: ProductoListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'producto/agregar',
    component: ProductoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'producto/agregar/:idTipoProductoBancario',
    component: ProductoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'producto/actualizar/:id',
    component: ProductoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'producto/detalle/:id',
    component: ProductoDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },

  // Productos Troncal
  { path: 'productos-troncal', component: ProductosTroncalComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'productos-troncal/agregar',
    component: ProductosTroncalEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'productos-troncal/actualizar/:id',
    component: ProductosTroncalEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'productos-troncal/detalle/:id',
    component: ProductosTroncalDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },


  // politicas
  { path: 'politicas-credito', component: PoliticasCreditoListadoComponent },
  { path: 'politicas-credito/agregar', component: PoliticasCreditoEditarComponent },
  { path: 'politicas-credito/actualizar/:id', component: PoliticasCreditoEditarComponent },
  {
    path: 'politicas-credito/detalle/:id',
    component: PoliticasCreditoDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Conceptos de facturacion
  { path: 'concepto-facturacion', component: ConceptoFacturacionListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'concepto-facturacion/agregar',
    component: ConceptoFacturacionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'concepto-facturacion/actualizar/:id',
    component: ConceptoFacturacionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'concepto-facturacion/detalle/:id',
    component: ConceptoFacturacionDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Controles
  { path: 'control', component: ControlListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'control/agregar',
    component: ControlEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'control/actualizar/:id',
    component: ControlEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  // Palabras claves
  { path: 'palabra-clave', component: PalabraClaveListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'palabra-clave/agregar',
    component: PalabraClaveEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'palabra-clave/actualizar/:id',
    component: PalabraClaveEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'palabra-clave/detalle/:id',
    component: PalabraClaveDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Sincronizaciones
  { path: 'sincronizacion', component: SincronizacionListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'sincronizacion/agregar',
    component: SincronizacionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'sincronizacion/actualizar/:id',
    component: SincronizacionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  // Tipo causal
  { path: 'tipo-causal', component: TipoCausalListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'tipo-causal/actualizar/:id',
    component: TipoCausalEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  // Tipo ocupación configuracióm
  {
    path: 'tipo-ocupacion-configuracion',
    component: TipoOcupacionConfiguracionListadoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'tipo-ocupacion-configuracion/agregar',
    component: TipoOcupacionConfiguracionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'tipo-ocupacion-configuracion/actualizar/:id',
    component: TipoOcupacionConfiguracionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'tipo-ocupacion-configuracion/detalle/:id',
    component: TipoOcupacionConfiguracionDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  {
    path: 'tipo-ocupacion-configuracion/CapacidadPago/:id',
    component: CapacidadPagoOcupacionComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  // Central Riesgo
  {
    path: 'central-riesgo-integracion',
    component: CentralRiesgoIntegracionListadoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'central-riesgo-integracion/agregar',
    component: CentralRiesgoIntegracionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'central-riesgo-integracion/actualizar/:id',
    component: CentralRiesgoIntegracionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'central-riesgo-integracion/detalle/:id',
    component: CentralRiesgoIntegracionDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Cuenta Contable
  { path: 'cuenta-contable', component: CuentaContableComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  // Seguro
  { path: 'seguro', component: SeguroListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'seguro/agregar', component: SeguroEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'seguro/actualizar/:id', component: SeguroEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'seguro/detalle/:id', component: SeguroDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },
  // Meta Venta
  { path: 'seguro/meta-venta', component: MetaVentaSegurosComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Tasas variable
  { path: 'tasas-variables', component: TasasVariablesListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'tasas-variables/agregar',
    component: TasasVariablesEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'tasas-variables/actualizar/:id',
    component: TasasVariablesEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'tasas-variables/detalle/:id',
    component: VerDetalleTasasComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Tipo Respaldo
  { path: 'tipo-respaldo', component: TipoRespaldoListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'tipo-respaldo/agregar',
    component: TipoRespaldoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'tipo-respaldo/configurar/:id',
    component: TipoRespaldoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'tipo-respaldo/detalle/:id',
    component: TipoRespaldoDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  {
    path: 'tipo-respaldo/detalle-subcategoria/:id',
    component: TipoRespaldoDetalleSubcategoriaComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // .........................................................  requisitos .................................................
  { path: 'requisitos', component: RequisitosListadoComponent },
  { path: 'requisitos/agregar', component: RequisitosEditarComponent },
  { path: 'requisitos/actualizar/:id', component: RequisitosEditarComponent },
  { path: 'requisitos/detalle/:id', component: RequisitosDetalleComponent },
  // Asignar Estructuras a oficinas
  {
    path: 'estructura-fisica/estructura-oficina/:id',
    component: EstructuraOficinaComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  // Vinculacion de terceros
  { path: 'vinculacion-tercero', component: VinculacionTerceroComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'vinculacion-tercero/configurar-vinculacion/:id',
    component: VinculacionTerceroVinculacionComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'vinculacion-tercero/configurar-ocupacion/:id',
    component: VinculacionTerceroOcupacionComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'vinculacion-tercero/configurar-vinculacion/detalle-submenu/:id',
    component: VinculacionTerceroDetalleSubmenuComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // menú visita
  { path: 'menu-visita', component: MenuVisitaComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  // Proceso productivo
  { path: 'proceso-productivo', component: ProcesoProductivoListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'proceso-productivo/agregar',
    component: ProcesoProductivoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'proceso-productivo/actualizar/:id',
    component: ProcesoProductivoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'proceso-productivo/detalle/:id',
    component: ProcesoProductivoDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // Plaga
  { path: 'plaga', component: PlagaListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'plaga/agregar', component: PlagaEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'plaga/actualizar/:id', component: PlagaEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'plaga/detalle/:id', component: PlagaDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },
  // Forma desembolso
  { path: 'forma-desembolso', component: FormaDesembolsoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Modalidades
  { path: 'modalidades', component: ModalidadesListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'modalidades/agregar',
    component: ModalidadesEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'modalidades/actualizar/:id',
    component: ModalidadesEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'modalidades/detalle/:id',
    component: ModalidadesDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },

  // Alertas
  { path: 'alertas', component: AlertaListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'alertas/agregar', component: AlertaEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'alertas/actualizar/:id', component: AlertaEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'alertas/detalle/:id', component: AlertaDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },

  // Cambio Perfil
  { path: 'cambio-perfil', component: CambioPerfilComponent, data: { modulo: modulo } },
  { path: 'cambio-perfil/actualizar/:id', component: CambioPerfilEditarComponent, data: { tipo: [ 'E' ], modulo: modulo } },

  // Convenios
  {
    path: 'convenios', component: ConveniosComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'convenios/agregar', component: ConveniosEditarComponent, canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'convenios/actualizar/:id',
    component: ConveniosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'convenios/detalle/:id',
    component: ConveniosDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },

  // Vinculación estado financiero
  {
    path: 'vinculacion-estado-financiero',
    component: VinculacionEstadoFinancieroComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  // Homologacion de estados
  { path: 'homologacion-estado', component: HomologacionEstadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  // Fases
  { path: 'fases', component: FaseListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'fases/agregar', component: FaseEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'fases/actualizar/:id', component: FaseEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'fases/detalle/:id', component: FaseDetalleComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },

  // excepciones-gmf
  { path: 'excepciones-gmf', component: ExcepcionesGmfListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'excepciones-gmf/agregar',
    component: ExcepcionesGmfEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'excepciones-gmf/actualizar/:id',
    component: ExcepcionesGmfEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'excepciones-gmf/detalle/:id',
    component: ExcepcionesGmfDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },

  // campanias
  { path: 'campanias', component: CampaniasListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'campanias/agregar', component: CampaniasEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  {
    path: 'campanias/actualizar/:id',
    component: CampaniasEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },
  {
    path: 'campanias/detalle/:id',
    component: CampaniasDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'V' ], modulo: modulo }
  },
  // alfresco
  {
    path: 'alfresco',
    component: AlfrescoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },

  // Sistemas
  { path: 'sistemas', component: SistemaListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'sistemas/agregar', component: SistemaEditarComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  {
    path: 'sistemas/actualizar/:id',
    component: SistemaEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'E' ], modulo: modulo }
  },

  // Configuraciones Url Externas
  { path: 'extensiones-telefonicas', component: ExtensionesTelefonicasListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'extensiones-telefonicas/agregar', component: ExtensionesTelefonicasEditarComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'extensiones-telefonicas/actualizar/:id', component: ExtensionesTelefonicasEditarComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Solicitud bloqueo sarlaft
  { path: 'bloqueo-sarlaft', component: SolicitudBloqueoSarlaftListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Banco Errores Integraciones
  { path: 'banco-error-integracion', component: BancoErrorIntegracionListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'banco-error-integracion/agregar', component: BancoErrorIntegracionEditarComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'banco-error-integracion/actualizar/:id', component: BancoErrorIntegracionEditarComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'banco-error-integracion/detalle/:id', component: BancoErrorIntegracionDetalleComponent, data: { modulo: modulo } },

  // Flujo de venta
  {
    path: 'flujo-venta', component: FlujoVentaComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },

  // Paquetes Seguros

  { path: 'paquete-seguros',
    component: PaqueteSegurosListadoComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo } },
  {
    path: 'paquete-seguros/agregar',
    component: PaqueteSegurosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },{
    path: 'paquete-seguros/actualizar/:id',
    component: PaqueteSegurosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },{
    path: 'paquete-seguros/detalle/:id',
    component: PaqueteSegurosDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },

  // Matriz identidad

  // { path: 'matriz-identidad',
  //   component: MatrizIdentidadListadoComponent, canActivate: [ AuthGuard ],
  //   data: { modulo: modulo } },
  // {
  //   path: 'matriz-identidad/agregar',
  //   component: MatrizIdentidadAgregarComponent,
  //   canActivate: [ AuthGuard ],
  //   data: { tipo: [ 'C' ], modulo: modulo }
  // },{
  //   path: 'matriz-identidad/actualizar/:id',
  //   component: MatrizIdentidadEditarComponent,
  //   canActivate: [ AuthGuard ],
  //   data: { tipo: [ 'C' ], modulo: modulo }
  // },

  // Administrador de Garantías (ADMGAR)

  { path: 'administrador-garantias-idoneas', component: AdmgarComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Administrador de servicios bancarios (ADMSB)

  { path: 'administrador-servicios-bancarios', component: AdmsbListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'administrador-servicios-bancarios/titular/:id', component: AdmsbTitularComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'administrador-servicios-bancarios/titular/:id/tarifas/:idTerceroUPPasarelaProducto', component: AdmsbTarifasComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Garantias idoneas

  { path: 'garantia-idoneas',
    component: GarantiaIdoneasListadoComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo } },
  {
    path: 'garantia-idoneas/agregar',
    component: GarantiaIdoneasEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },{
    path: 'garantia-idoneas/actualizar/:id',
    component: GarantiaIdoneasEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },{
    path: 'garantia-idoneas/detalle/:id',
    component: GarantiaIdoneasDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },

  // Tipo Productores

  { path: 'tipo-productores',
    component: TipoProductoresListadoComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo } },
  {
    path: 'tipo-productores/agregar',
    component: TipoProductoresEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },{
    path: 'tipo-productores/actualizar/:id',
    component: TipoProductoresEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },{
    path: 'tipo-productores/detalle/:id',
    component: TipoProductoresDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },

  // Plan de cargo

  {
    path: 'plan-cargo',
    component: PlanesCargosListadosComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'plan-cargo/agregar',
    component: PlanesCargosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'plan-cargo/actualizar/:id',
    component: PlanesCargosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'plan-cargo/detalle/:id',
    component: PlanesCargosDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },

  // Politica duras

  {
    path: 'politicas-duras',
    component: PoliticasDurasListadoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'politicas-duras/agregar',
    component: PoliticasDurasEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'politicas-duras/actualizar/:id',
    component: PoliticasDurasEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'politicas-duras/detalle/:id',
    component: PoliticasDurasDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },

  // Configuracion canales - estados
  { path: 'configuracion-canal-estado', component: ConfiguracionCanalEstadoListadoComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'configuracion-canal-estado/agregar', component: CanalEstadoFormComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'configuracion-canal-estado/actualizar/:id', component: CanalEstadoFormComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'configuracion-canal-estado/detalle/:id', component: CanalEstadoDetalleComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Politicas
  { path: 'politicas', component: PoliticasComponent, canActivate: [ AuthGuard ],  data: { modulo: modulo } },
  // Unidades de medidas
  {
    path: 'unidades-medida', component: UnidadesMedidaComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  // Reglas del negocio
  {
    path: 'reglas-negocio', component: ReglasNegocioComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'pagaduria', component: PagaduriaListadoComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'pagaduria/agregar', component: PagaduriaComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'pagaduria/editar/:id', component: PagaduriaComponent, canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'pagaduria/detalle/:id',
    component: PagaduriaDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },

  // Comisiones freelance

  {
    path: 'comision-freelance',
    component: ComisionFreelanceListadoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'comision-freelance/agregar',
    component: ComisionFreelanceEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'comision-freelance/actualizar/:id',
    component: ComisionFreelanceEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'comision-freelance/detalle/:id',
    component: ComisionFreelanceDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },

  // HOMOLOGACION PLAN DE CARGOS
  {
    path: 'homologacion-plan-cargo',
    component: HomologacionPlanesCargosListadoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'homologacion-plan-cargo/agregar',
    component: HomologacionPlanesCargosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'homologacion-plan-cargo/actualizar/:id',
    component: HomologacionPlanesCargosEditarComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },

  // CONVENIOS PLAN DE CARGOS
  {
    path: 'convenio-plan-cargo',
    component: ConveniosPlanCargoListadoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'convenio-plan-cargo/agregar',
    component: ConveniosPlanCargoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'convenio-plan-cargo/actualizar/:id',
    component: ConveniosPlanCargoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'convenio-plan-cargo/detalle/:id',
    component: ConveniosPlanCargosDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'comite-de-credito',
    component: ComiteCreditoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },

  // SERVIDORES ALFRESCO
  {
    path: 'servidor-alfresco',
    component: ServidoresAlfrescoComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  {
    path: 'servidor-alfresco/agregar',
    component: ServidoresAlfrescoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'servidor-alfresco/actualizar/:id',
    component: ServidoresAlfrescoEditarComponent,
    canActivate: [ AuthGuard ],
    data: { modulo: modulo }
  },
  // SARLAF
  { path: 'sarlaft', component: SarlaftComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  { path: 'sarlaft/niveles-agregar', component: SarlaftEditarNivelesComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'sarlaft/niveles-actualizar/:id', component: SarlaftEditarNivelesComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'sarlaft/variables-agregar', component: SarlaftEditarVariablesComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'sarlaft/variables-actualizar/:id', component: SarlaftEditarVariablesComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'sarlaft/variables-detalle/:id', component: SarlaftEditarVariablesComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },

  // Simulador de credito
  { path: 'simulador-credito', component: SimuladorPantallaGeneralComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Perfil crezcamos
  { path: 'perfil-crezcamos', component: PerfilCrezcamosGeneralComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },

  // Topes inversiones
  { path: 'tope-inversion', component: TopeInversionComponent, canActivate: [ AuthGuard ], data: { modulo: modulo } },
  {
    path: 'tope-inversion/agregar',
    component: TopeInversionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'tope-inversion/actualizar/:id',
    component: TopeInversionEditarComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  {
    path: 'tope-inversion/detalle/:id',
    component: TopeInversionDetalleComponent,
    canActivate: [ AuthGuard ],
    data: { tipo: [ 'C' ], modulo: modulo }
  },
  // Vigencias APL
  { path: 'vigencias', component: VigenciasAplComponent , canActivate: [ AuthGuard ], data: { modulo: modulo }  },
  { path: 'vigencias/validity-requests-edit/:id', component: ValidityRequestsAddComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'vigencias/validity-employees-edit/:id', component: ValidityEmployeesAddComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'vigencias/administration-documents-add', component: AdministrationDocumentsAddComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'C' ], modulo: modulo } },
  { path: 'vigencias/administration-documents-edit/:id', component: AdministrationDocumentsAddComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'E' ], modulo: modulo } },
  { path: 'vigencias/administration-documents-detail/:id', component: AdministrationDocumentsDetailComponent, canActivate: [ AuthGuard ], data: { tipo: [ 'V' ], modulo: modulo } },

];


@NgModule( {
  imports: [ RouterModule.forChild( aplRoutes ), CommonModule ],
  exports: [ RouterModule ],
  providers: []
} )

export class AplRoutingModule {
}

